import { first, map } from 'rxjs/operators';
import { createRouter, createWebHistory, RouteRecordRaw, Router } from 'vue-router';

import { WorkspaceType } from '@skinsoft/types';
import { CommonRoutes, AuditRoutes } from '@skinsoft/const';
import { AuthService } from '@skinsoft/auth';
import { Login } from '@skinsoft/auth-ui'

import { router as unifiedRouter } from '../../../reporter-launcher/src/router' // TODO better'
import { RecordSearchScreen } from './app/component/audit-campaign-records/record-search-screen';
import { AuditCampaignSearchMenu } from './app/component/audit-campaign-search/audit-campaign-search-menu';
import { AuditCampaignSearchScreen } from './app/component/audit-campaign-search/audit-campaign-search-screen';
import { RecordEditScreen } from './app/component/record-edit-screen';
import { RecordEditMenu } from './app/component/record-edit-screen/record-edit-menu';
import { ItemSearchScreen } from '../../../lib/@skinsoft/search/src/search-screen/item-search-screen'
import { ArchiveSearchScreen } from '../../../lib/@skinsoft/search/src/search-screen/archive-search-screen'
import { SpecimenSearchScreen } from '../../../lib/@skinsoft/search/src/search-screen/specimen-search-screen'
import { SoloItemEditScreen } from '@skinsoft/entity-ui/src/item/components/solo-item-edit-screen'
import { AuditItemEditScreen } from './app/component/audit-item-edit-screen';
import { AuditItemEditMenu } from './app/component/audit-item-edit-screen/audit-item-edit-menu';
import { ActionType } from '@skinsoft/ui';
import { ArchiveEditScreen, SpecimenEditScreen } from '@skinsoft/pages'

declare var UNIFY_ROUTER: boolean;

const routes = [
    {
        name: AuditRoutes.AUDIT_HOME,
        path: '/auditHome',
        redirect: to => {
            const workspaceType = localStorage.getItem("workspaceType")

            if(workspaceType) {
                switch(workspaceType) {
                    case WorkspaceType.archive:
                        return { name: CommonRoutes.ARCHIVES }
                    case WorkspaceType.specimen:
                        return { name: CommonRoutes.SPECIMENS }
                }
            }

            return { name: CommonRoutes.ITEMS }
        },
    },

    {
        component: ItemSearchScreen,
        name: CommonRoutes.ITEMS,
        path: '/items',
        props: {
            titleI18NKey: "auditCampaignSearchScreen.title",
            canCreateObject: true,
            targetRouteName: CommonRoutes.ITEM,
            onlyUploaded: true,
            displayedButtons: [
                {
                    type: 'camera',
                    icon: 'camera',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'modifyItemRecord',
                    icon: 'edit',
                    class: 'new-cr-from-last',
                    dataCy: 'item-search-screen--edit-item-btn',
                }
            ],
            titleClickAction: {
                action: ActionType.EDIT,
                targetRouteName: CommonRoutes.ITEM
            }
        }
    },
    {
        component: ArchiveSearchScreen,
        name: CommonRoutes.ARCHIVES,
        path: '/archives',
        props: {
            titleI18NKey: "auditCampaignSearchScreen.title",
            canCreateObject: true,
            targetRouteName: CommonRoutes.ARCHIVE,
            onlyUploaded: true,
            displayedButtons: [
                {
                    type: 'camera',
                    icon: 'camera',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'modifyItemRecord',
                    icon: 'edit',
                    class: 'new-cr-from-last',
                    dataCy: 'item-search-screen--edit-item-btn',
                }
            ],
            titleClickAction: {
                action: ActionType.EDIT,
                targetRouteName: CommonRoutes.ARCHIVE
            }
        }
    },
    {
        component: SpecimenSearchScreen,
        name: CommonRoutes.SPECIMENS,
        path: '/specimens',
        props: {
            titleI18NKey: "auditCampaignSearchScreen.title",
            canCreateObject: true,
            targetRouteName: CommonRoutes.SPECIMEN,
            onlyUploaded: true,
            displayedButtons: [
                {
                    type: 'camera',
                    icon: 'camera',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'modifySpecimenRecord',
                    icon: 'edit',
                    class: 'new-cr-from-last',
                    dataCy: 'specimen-search-screen--edit-specimen-btn',
                }
            ],
            titleClickAction: {
                action: ActionType.EDIT,
                targetRouteName: CommonRoutes.SPECIMEN
            }
        },
    },
    {
        component: AuditCampaignSearchScreen,
        name: AuditRoutes.CAMPAIGN_SEARCH,
        path: '/campaigns',
        props: {
            titleI18NKey: "auditCampaignSearchScreen.title"
        }
    },
    {
        components: {
            actionMenu: AuditCampaignSearchMenu,
            default: RecordSearchScreen,
        },
        name: AuditRoutes.CAMPAIGN,
        path: '/campaign/:campaignId',
    },
    {
        components: {
            actionMenu: RecordEditMenu,
            default: RecordEditScreen,
        },
        name: AuditRoutes.RECORD,
        path: '/record/:campaignId/:recordId',
        props: {
            default: true
        }
    },
    {
        components: {
            actionMenu: AuditItemEditMenu,
            default: SoloItemEditScreen,
        },
        name: CommonRoutes.ITEM,
        path: '/item/:itemId',
        props: {
            default: route => ({
                itemId: route.params.itemId,
                itemEditScreen: AuditItemEditScreen,
                routes: {
                    offlineRoute: AuditRoutes.NEW_ITEMS,
                    onlineRoute: AuditRoutes.AUDIT_HOME
                }
            }),
        }
    },
    {
        components: {
            actionMenu: AuditItemEditMenu,
            default: ArchiveEditScreen,
        },
        name: CommonRoutes.ARCHIVE,
        path: '/archive/:archiveId',
        props: {
            default: route => ({
                archiveId: route.params.archiveId,
                navigateBackRoute: AuditRoutes.AUDIT_HOME,
            }),
        }
    },
    {
        components: {
            actionMenu: AuditItemEditMenu,
            default: SpecimenEditScreen,
        },
        name: CommonRoutes.SPECIMEN,
        path: '/specimen/:specimenId',
        props: {
            default: route => ({
                specimenId: route.params.specimenId,
                navigateBackRoute: AuditRoutes.AUDIT_HOME,
            }),
        }
    },
    {
        
        component: ItemSearchScreen,
        name: AuditRoutes.NEW_ITEMS,
        path: '/newItems',
        props: {
            onlyNewItems: true,
            canCreateObject: true,
            displayedButtons: [
                {
                    type: 'camera',
                    icon: 'camera',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'modifyItemRecord',
                    icon: 'edit',
                    class: 'new-cr-from-last',
                    dataCy: 'item-search-screen--edit-item-btn',
                }
            ],
            targetRouteName: CommonRoutes.ITEM
        }
    },
    {
        component: SpecimenSearchScreen,
        name: AuditRoutes.NEW_SPECIMENS,
        path: '/newSpecimens',
        props: {
            onlyNewSpecimens: true,
            canCreateObject: true,
            displayedButtons: [
                {
                    type: 'camera',
                    icon: 'camera',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'modifySpecimenRecord',
                    icon: 'edit',
                    class: 'new-cr-from-last',
                    dataCy: 'specimen-search-screen--edit-specimen-btn',
                }
            ],
            targetRouteName: CommonRoutes.SPECIMEN,
            titleClickAction: {
                action: ActionType.EDIT,
                targetRouteName: CommonRoutes.SPECIMEN
            }
        },
    },
    { path: '/:pathMatch(.*)*', redirect: '/auditHome' }
]

// tslint:disable-next-line:variable-name
let _router: Router;

// If app is embedded in launcher, use launcher router
if (UNIFY_ROUTER) {
    _router = unifiedRouter
}
// If app is standalone, use its own router
else {
    _router = createRouter({
        history: createWebHistory(),
        routes: [],
    });
    _router.addRoute({
        component: Login,
        name: CommonRoutes.LOGIN,
        props: {
            homeRoute: AuditRoutes.AUDIT_HOME
        },
        path: '/login',
    })
}
// cast: vue-router 4 infers this array as a union of record literals, not RouteRecordRaw[].
routes.forEach(route => _router.addRoute(route as RouteRecordRaw))

export const router = _router;

router.beforeEach((to, __, next) => {
    AuthService.getInstance()
        .waitForUser$()
        .pipe(
            first(),
            map(authenticated => {
                if (!(authenticated && authenticated.user) && to.name !== CommonRoutes.LOGIN) {
                    return { name: CommonRoutes.LOGIN };
                }

                if (authenticated && authenticated.user && to.name === CommonRoutes.LOGIN) {
                    return false;
                }

                return;
            }),
        )
        .subscribe(next);
});
